import * as tslib_1 from "tslib";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import noop from 'lodash/noop';
import "./Label.css";
var CONTAINER_HEIGHT = 16;

var Label =
/** @class */
function (_super) {
  tslib_1.__extends(Label, _super);

  function Label() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getContainerHeightStyleObj = function () {
      var _a = _this.props,
          containerHeight = _a.containerHeight,
          multiline = _a.multiline;
      if (multiline) return {};

      if (typeof containerHeight === 'boolean') {
        return containerHeight ? {
          height: CONTAINER_HEIGHT
        } : {};
      }

      return {
        height: containerHeight
      };
    };

    return _this;
  }

  Label.prototype.renderLabel = function () {
    var _a = this.props,
        text = _a.text,
        blockClassName = _a.blockClassName,
        labelClassName = _a.labelClassName,
        inputId = _a.inputId,
        onClick = _a.onClick;
    return React.createElement("label", {
      className: blockClassName + "__block",
      onClick: onClick,
      htmlFor: inputId
    }, React.createElement("span", {
      className: cx(blockClassName + "__text", labelClassName)
    }, text));
  };

  Label.prototype.render = function () {
    var _a;

    var _b = this.props,
        align = _b.align,
        kind = _b.kind,
        multiline = _b.multiline,
        blockClassName = _b.blockClassName,
        containerClassName = _b.containerClassName,
        disabled = _b.disabled,
        isError = _b.isError,
        isActive = _b.isActive,
        children = _b.children;
    var finalClassName = cx(blockClassName, (_a = {}, _a[blockClassName + "--" + align] = align, _a[blockClassName + "--" + kind] = kind, _a[blockClassName + "--multiline"] = multiline, _a[blockClassName + "--disabled"] = disabled, _a[blockClassName + "--error"] = isError, _a[blockClassName + "--disabled-error"] = isError && disabled, _a[blockClassName + "--active"] = isActive, _a), containerClassName);

    if (align === 'control') {
      return React.createElement("div", {
        className: finalClassName,
        style: this.getContainerHeightStyleObj()
      }, children, this.renderLabel());
    }

    return React.createElement("div", {
      className: finalClassName
    }, this.renderLabel(), children);
  };

  Label.propTypes = {
    text: PropTypes.node.isRequired,
    align: PropTypes.oneOf(['in', 'out', 'control']),
    multiline: PropTypes.bool,

    /** Can be used for field styling as the label becomes its container. */
    kind: PropTypes.string,
    blockClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    labelClassName: PropTypes.string,

    /** `for` of native `<label>`. */
    inputId: PropTypes.string,
    children: PropTypes.node,

    /** Container's height, for align='control' only.  */
    containerHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    disabled: PropTypes.bool,
    isError: PropTypes.bool,
    isActive: PropTypes.bool,
    onClick: PropTypes.func
  };
  Label.defaultProps = {
    align: 'in',
    multiline: false,
    blockClassName: 'nx-label',
    containerHeight: CONTAINER_HEIGHT,
    disabled: false,
    isError: false,
    isActive: false,
    onClick: noop
  };
  return Label;
}(PureComponent);

export default Label;

try {
  // @ts-ignore
  Label.__docgenInfo = {
    "description": "",
    "displayName": "Label",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}